





















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ReferralButton from 'frontend/views/referral/components/ReferralButton.vue';
import { mapGetters } from 'vuex';
import { MobileGetter } from 'frontend/types';

@Component({
  components: {
    ReferralButton,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class Blurb extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop({ required: true }) description!: string;
  @Prop() spriteClass: string | undefined;
  @Prop() imageSrc: string | undefined;
  @Prop() imageAlt: string | undefined;
  @Prop() buttonText: string | undefined;
  @Prop({ default: false }) darkBgTheme!: boolean;
  @Prop({ default: false }) largeTheme!: boolean;
  @Prop({ default: false }) referralTheme!: boolean;
  @Prop({ default: false }) loading!: boolean;

  private isMobile!: MobileGetter;

  private clickHandler(): void {
    this.$emit('button-clicked');
  }
}
